import {
  TableCell,
  TableRow,
  TableText,
} from "../../../../../../../Components/FinalTable";

import { convDate } from "./../../../../../../../Util/Time";

import TActions from "./TActions";

import { MdOutlineHistoryToggleOff } from "react-icons/md";

import { useNavigate } from "react-router-dom";

const TRow = ({ doc }) => {
  const navigate = useNavigate();
  return (
    <TableRow>
      <TableCell w={90 / 7}>
        <TableText label={`${doc.first_name} ${doc.second_name}`} />
      </TableCell>
      <TableCell w={90 / 7}>
        <TableText label={doc.email || ""} />
      </TableCell>
      <TableCell w={90 / 7}>
        <TableText label={doc.phone || ""} />
      </TableCell>
      <TableCell w={90 / 7}>
        <TableText label={doc.id_no || ""} />
      </TableCell>
      <TableCell w={90 / 7}>
        <TableText label={convDate(parseInt(doc.dob))} />
      </TableCell>
      <TableCell w={90 / 7}>
        <TableText label={doc.gender} />
      </TableCell>
      <TableCell w={90 / 7}>
        <div
          className=" text-2xl px-4 py-1 rounded-md bg-primary  cursor-pointer inline-block  text-white active:opacity-50"
          style={{ width: "auto" }}
          onClick={() => navigate(`/dashboard/medical-history/${doc?.id}`)}
        >
          <MdOutlineHistoryToggleOff />
        </div>
      </TableCell>
      <div style={{ width: "10%" }} className=" ">
        <TActions doc={doc} />
      </div>
    </TableRow>
  );
};

export default TRow;
